import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "../api";
import { useStore } from "../store";
import ProductFeed from "../components/ProductFeed";

export default function Category() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { categories } = useStore();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const category = categories.find((c) => c.slug === slug);

  useEffect(() => {
    setLoading(true);
    api.get("/products", { params: { category: slug } })
      .then((r) => setProducts(r.data.products))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <div className="max-w-5xl mx-auto" data-testid="category-page">
      <div className="flex items-center gap-3 px-4 pt-5 pb-2">
        <button
          data-testid="back-button"
          onClick={() => navigate(-1)}
          aria-label="Torna indietro"
          className="p-2 -ml-2 text-[#2C2C2C] hover:opacity-60 transition-opacity duration-200"
        >
          <ArrowLeft size={20} strokeWidth={1.5} />
        </button>
      </div>
      <div className="text-center mb-10 px-4">
        <h1 className="font-display text-3xl text-[#2C2C2C]" data-testid="category-title">{category?.name || slug}</h1>
        <div className="gold-line w-24 mx-auto mt-4" />
      </div>
      <div className="pb-20">
        <ProductFeed products={products} loading={loading} />
      </div>
    </div>
  );
}
